import { useGetImageNodeByPath } from './get-image-node-by-path';

export const useGetImageFullPath = (path: string): string => {
  return `${process.env.SITE_URL}${useGetImageNodeByPath(path).publicURL}`;
};
